<!--
  The app's Early Access ribbon (Ribbon.svelte). Signed in, it opens the
  feedback form, by the command the form's key carries out; signed out it
  links to the operator's support address when one is set, and is a label
  when none is.

  A top bar draws its own (`bar`), after the wordmark in the tab order, and
  it stays with the bar. The page draws one too, for the screens that have
  no top bar (sign-in, loading, the server unreachable): that one shows
  only while no bar's does, so there is always exactly one.
-->
<script lang="ts" module>
  /** How many top bars are drawing the ribbon. */
  let bars = $state(0);
</script>

<script lang="ts">
  import { untrack } from 'svelte';
  import { keyboard } from '../keys/keyboard.svelte';
  import { supportLink } from '../logic/operatorLinks';
  import { session } from '../state/session.svelte';
  import Ribbon from './Ribbon.svelte';

  interface Props {
    /** Drawn inside a top bar. */
    bar?: boolean;
  }
  let { bar = false }: Props = $props();

  // Counted before the page draws, so the page's own ribbon never shows beside a bar's.
  $effect.pre(() => {
    if (!bar) return;
    untrack(() => bars++);
    return () => void untrack(() => bars--);
  });

  const support = $derived(supportLink(session.operatorLinks));
</script>

{#if bar || bars === 0}
  {#if session.user}
    <Ribbon onactivate={() => keyboard.run({ kind: 'open', menu: 'feedback' })} />
  {:else if support}
    <Ribbon href={support.href} newTab={support.newTab} />
  {:else}
    <Ribbon />
  {/if}
{/if}
